/* eslint-disable no-restricted-imports -- the wrapper module is the moment island during the shadow window; raw moment access is required to delegate the Moment side of the comparison. */
import moment from 'moment';

import { dayjsApi, formatSerializer, runShadow } from './shadow-runner';
import type { DomainNameType } from './subdomains';

type TagShapeType = { domain: DomainNameType; subdomain: string };

export function shadowParseZone(tags: TagShapeType) {
  return (input: string) => {
    return runShadow({
      op: 'parseZone',
      ...tags,
      inputs: [input],
      computeMoment: () => moment.parseZone(input),
      computeDayjs: () => dayjsApi.parseZone(input),
      serialize: formatSerializer,
    });
  };
}
